import { Dropdown, Loader } from "@/components";
import { Bell, BellNotification } from "@/icons";
import { useTranslate, useNotifications } from "@/providers/context";
import { NotificationCard } from "./components/NotificationCard";

const ICON_CLASS = "hover:text-item-secondary h-6 w-6";

export const NotificationsDropdown = () => {
  const {
    isEnabled,
    notifications,
    hasUnreadNotifications,
    markAsRead,
    isError,
  } = useNotifications();
  const { translate } = useTranslate();

  if (!isEnabled || isError) {
    return null;
  }

  return (
    <Dropdown
      onOpenChange={(open) => {
        if (!open) {
          // Mark as read once dropdown is closed, so unread state is visible while opened
          markAsRead();
        }
      }}
      contentProps={{ align: "end", alignOffset: 24 }}
      customContent={
        <div className="w-[426px]">
          {!notifications ? (
            <div className="flex h-[609px] w-full items-center justify-center">
              <Loader className="h-8 w-8 text-item-secondary" />
            </div>
          ) : notifications.length === 0 ? (
            <div className="flex h-[609px] flex-col items-center justify-center gap-4 text-center">
              <Bell className="h-[68px] w-[68px]" />
              <div className="flex flex-col items-center gap-2">
                <div className="h4-extrabold">
                  {translate("No notifications")}
                </div>
                <div className="p1 p2-regular text-item-secondary">
                  {translate("You have no notifications")}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex max-h-[609px] w-full flex-col overflow-y-auto p-5">
              {notifications.map((n, idx) => (
                <NotificationCard
                  key={n.id}
                  notification={n}
                  isUnread={n.isUnread}
                  isLast={idx === notifications.length - 1}
                />
              ))}
              <div className="caption-normal mt-auto w-full pb-2 pt-10 text-center text-item-secondary">
                {translate("Notifications shown are from the last 30 days")}
              </div>
            </div>
          )}
        </div>
      }
    >
      {hasUnreadNotifications ? (
        <BellNotification className={ICON_CLASS} />
      ) : (
        <Bell className={ICON_CLASS} />
      )}
    </Dropdown>
  );
};
